// components/cards/UserAvatar.jsx
import Person2Icon from "@mui/icons-material/Person2";
import { Box, CardMedia } from "@mui/material";
import { useEffect, useRef } from "react";
import useFiles from "../../hooks/useFiles";
import { DOWNLOAD_FILE } from "../../constants/apiUrls";

export default function UserAvatar({ user, size = 100 }) {
  const { blobUrl, getImageUrl } = useFiles();
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          getImageUrl(
            user.savedFileUUID || user.profilePhotoUUID,
            DOWNLOAD_FILE,
          );
          observer.disconnect();
        }
      },
      { rootMargin: "200px 0px" },
    );

    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [user?.uuid, user?.savedFileUUID, user?.profilePhotoUUID, getImageUrl]);

  return (
    <Box
      ref={ref}
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: "50%",
        overflow: "hidden",
        backgroundColor: "lightGray",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {blobUrl ? (
        <CardMedia
          component="img"
          image={blobUrl}
          alt={`${user.firstName} ${user.lastName}`}
          loading="lazy"
          sx={{
            height: size,
            width: size,
            objectFit: "cover",
          }}
          onError={(e) => {
            e.target.src = "/placeholder-asset.jpg";
            e.target.alt = "Image failed to load";
          }}
        />
      ) : (
        <Person2Icon sx={{ fontSize: size * 0.7 }} />
      )}
    </Box>
  );
}
